import { render, staticRenderFns } from "./VideoEquipment.vue?vue&type=template&id=2aafeb4f&scoped=true&"
import script from "./VideoEquipment.vue?vue&type=script&lang=js&"
export * from "./VideoEquipment.vue?vue&type=script&lang=js&"
import style0 from "./VideoEquipment.vue?vue&type=style&index=0&id=2aafeb4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aafeb4f",
  null
  
)

export default component.exports